import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

export const login = (email, password) => {
  return axios.post(`${API_URL}customers/login`, { email, password });
};

export const register = (customer) => {
  return axios.post(`${API_URL}customers/register`, customer);
};

export const createPurchase = (purchase) => {
  return axios.post(`${API_URL}purchases`, purchase);
};

export const getPurchases = (customerId) => {
  return axios.get(`${API_URL}purchases/customer/${customerId}`);
};

export const getServices = () => {
  return axios.get(`${API_URL}services`);
};

export const getNotifications = () => {
  return axios.get(`${API_URL}notifications`);
};

export const registerUser = (user) => {
  return axios.post(`${API_URL}admin/register`, user);
};

export const loginAdmin = (email, password) => {
  return axios.post(`${API_URL}admin/login`, { email, password });
};

export const registerCustomer = (customer) => {
  const token = localStorage.getItem("adminToken");
  return axios.post(`${API_URL}admin/register-customer`, customer, {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });
};

export const getAllCustomers = () => {
  const token = localStorage.getItem("adminToken");
  return axios.get(`${API_URL}customers/all`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export const getTicketDetails = (customerId) => {
  const token = localStorage.getItem("token");
  return axios.get(`${API_URL}support/tickets/customer/${customerId}/`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export const sendResponse = (ticketId, customerEmail, response) => {
  const token = localStorage.getItem("adminToken");
  return axios.post(
    `${API_URL}response/send-response`,
    { ticketId, customerEmail, response },
    {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    }
  );
};

export const createTicket = (data) => {
  const token = localStorage.getItem("token");
  const customerId = localStorage.getItem("customerId");

  return axios.post(`${API_URL}support/tickets`, data, {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
      customer_id: customerId,
    },
  });
};


export const getCustomerProfile = () => {
  const token = localStorage.getItem("token");
  return axios.get(`${API_URL}customers/profile`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export const getAllPurchases = () => {
  const token = localStorage.getItem("adminToken");
  return axios.get(`${API_URL}purchases`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export const getAdminRequests = (token) => {
  return axios.get(`${API_URL}admin/staff-registration-requests`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

// Approve Admin Request
export const approveRequest = (adminId, token) => {
  return axios.post(
    `${API_URL}admin/approve`,
    {
      adminId,
      status: "approved",
    },
    {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    }
  );
};

// Reject Admin Request
export const rejectRequest = (adminId, token) => {
  return axios.post(
    `${API_URL}admin/reject`,
    {
      adminId,
      status: "rejected",
    },
    {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    }
  );
};

export const fetchCustomerDetails = (token) => {
  return axios.get(`${API_URL}customers/details`, {
    headers: { Authorization: `Bearer ${token}` },
  });
};

// Redeem service
export const redeemService = (token, invoiceNo, productSku) => {
  return axios.post(
    `${API_URL}customers/use-service`,
    { invoiceNo, productSku },
    {
      headers: { Authorization: `Bearer ${token}` },
    }
  );
};

export const fetchAdminProfile = (token) => {
  return axios.get(`${API_URL}admin/profile`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export const setCustomerPassword = (token, password, confirmPassword) => {
  return axios.post(`${API_URL}customers/set-password`, {
    token,
    password,
    confirmPassword,
  });
};

export const setAdminPassword = (token, password, confirmPassword) => {
  return axios.post(`${API_URL}admin/set-password`, {
    token,
    password,
    confirmPassword,
  });
};